import {CustomInputRinforzoValue} from "../types";
import {MessageDescriptor} from "react-intl";

export const TIPOLOGIA_OPTIONS = {
  gmxsf: "Geolite Magma Xenon e Steel Fiber",
  gmsf: "Geolite Magma e Steel Fiber",
  gmre: "Geolite Magma e rete elettrosaldata",
  other: "Altra tipologia",
  // mst: "Malta Semi-Tixo",
};

export const CLASSE_CLS_OPTIONS = [
  "C8/10",
  "C12/15",
  "C16/20",
  "C20/25",
  "C25/30",
  "C28/35",
  "C32/40",
  "C35/45",
  "C40/50",
];

export const CLASSE_CLS_OPTIONS_VALUES: {[key: string]: number} = {
  "C8/10": 8,
  "C12/15": 12,
  "C16/20": 16,
  "C20/25": 20,
  "C25/30": 25,
  "C28/35": 28,
  "C32/40": 32,
  "C35/45": 35,
  "C40/50": 40,
}

export const TENSILE_CURB_OPTIONS: {[key: string]: string} = {
  srg: "Sistema SRG",
  bb450c: "Barre da c.a. B450C",
}

export const SYSTEM_OPTIONS: {[key: string]: string} = {
  g600: "Geosteel G600 + Geocalce F Antisimico",
  g1200: "Geosteel G1200 + Geocalce F Antisimico",
}

export const ENVIRONMENTAL_EXPOSURE_OPTIONS = [
  "interna",
  "esterna",
  "aggressiva",
]

export const WALL_FLOOR_CONNECTION_OPTIONS = {
  scw_gfa: "Steel Connect Wall su muratura di laterizio inghisata con Gocalce FL Antisismico",
  scw_other: "Steel Connect Wall su altra tipologia muraria",
  // scw_ve: "Steel Connect Wall su muratura di laterizio inghisata con Vinilestere eco",
}

export const CUT_RESISTANCE_DEFAULT: number = 20;

export const FIELDS: {
  [key: string]: {
    required: boolean,
    numeric: boolean,
    localization: MessageDescriptor,
    options?: {[key: string]: string},
  }
} = {
  tipologia_rinforzo: {numeric: false, required: true, localization: {id: "reinforcement_type", defaultMessage: "Tipologia di rinforzo"}, options: TIPOLOGIA_OPTIONS},
  spessore_soletta: {numeric: true, required: true, localization: {id: "slab_thickness_mm", defaultMessage: "Spessore soletta [mm]"}},
  diametro_armatura_b450c: {numeric: false, required: false, localization: {id: "b450c_armor_diameter_mm", defaultMessage: "Diametro armatura B450C [mm]"}},
  passo_rete: {numeric: true, required: false, localization: {id: "net_step_mm", defaultMessage: "Passo rete [mm]"}},
  classe_cls: {numeric: false, required: false, localization: {id: "cls_class", defaultMessage: "Classe CLS"}},
  barre_b450c_rinforzo: {numeric: true, required: false, localization: {id: "b450c_bars_count", defaultMessage: "Numero barre"}},
  diametro_barre_b450c_rinforzo: {numeric: true, required: false, localization: {id: "b450c_bars_diameter_mm", defaultMessage: "Diametro barre [mm]"}},
  tipologia_cordolo: {numeric: false, required: true, localization: {id: "tensile_curb_type", defaultMessage: "Tipologia del cordolo a trazione"}, options: TENSILE_CURB_OPTIONS},
  sistema_cordolo: {numeric: false, required: false, localization: {id: "system", defaultMessage: "Sistema"}, options: SYSTEM_OPTIONS},
  numero_strati_cordolo: {numeric: true, required: false, localization: {id: "num_layers", defaultMessage: "Numero strati"}},
  altezza_fascia_cordolo: {numeric: true, required: false, localization: {id: "band_height_mm", defaultMessage: "Altezza fascia [mm]"}},
  esposizione_ambientale: {numeric: false, required: false, localization: {id: "environmental_exposure", defaultMessage: "Esposizione ambientale"}},
  barre_b450c_cordolo: {numeric: true, required: false, localization: {id: "b450c_bars_count", defaultMessage: "Numero barre"}},
  diametro_barre_b450c_cordolo: {numeric: true, required: false, localization: {id: "b450c_bars_diameter_mm", defaultMessage: "Diametro barre [mm]"}},
  wall_floor_connector: {numeric: false, required: true, localization: {id: "wall_floor_connector", defaultMessage: "Connettore parete solaio"}, options: WALL_FLOOR_CONNECTION_OPTIONS},
  resistenza_taglio: {numeric: true, required: false, localization: {id: "cut_resistence_kn", defaultMessage: "Resistenza a taglio media [kN]"}},
}

export const VALIDATE = (value?: CustomInputRinforzoValue) => {
  const invalid =
    !value
    || !value.tipologia_rinforzo
    || !value.spessore_soletta
    || (["gmre", "other"].includes(value.tipologia_rinforzo) && (
      !value.diametro_armatura_b450c
      || !value.passo_rete
    ))
    || (value.tipologia_rinforzo === "other" && (
      !value.classe_cls
    ))
    || (value.tipologia_cordolo === "srg" && (
      !value.sistema_cordolo
      || !value.numero_strati_cordolo
      || !value.altezza_fascia_cordolo
      || !value.esposizione_ambientale
    ))
    || (value.tipologia_cordolo === "bb450c" && (
      !value.barre_b450c_cordolo
      || !value.diametro_barre_b450c_cordolo
    ))
    || !value.wall_floor_connector
    || !value.resistenza_taglio;
  return !invalid;
}
